// extracted by mini-css-extract-plugin
export var balloon = "TalkMessage-module--balloon--1ac37";
export var balloonText = "TalkMessage-module--balloonText--3dd6b";
export var isFirstMessage = "TalkMessage-module--isFirstMessage--2ba3e";
export var timestamp = "TalkMessage-module--timestamp--cb12c";